var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.997,
    height: 13.552,
    viewBox: "0 0 15.997 13.552",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_System_Checkmark_16px",
    "data-name": "Icon/System/Checkmark/16px",
    transform: "translate(0.009 -1.327)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill_1",
    "data-name": "Fill 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1-2",
    "data-name": "Fill 1",
    d: "M5.817,13.552a1.13,1.13,0,0,1-.668-.218L0,9.567.59,8.76l5.149,3.767a.136.136,0,0,0,.188-.028L15.193,0l.8.6-9.266,12.5a1.137,1.137,0,0,1-.914.458",
    transform: "translate(-0.009 1.327)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1-3",
    "data-name": "Fill 1",
    d: "M5.817,13.552a1.13,1.13,0,0,1-.668-.218L0,9.567.59,8.76l5.149,3.767a.136.136,0,0,0,.188-.028L15.193,0l.8.6-9.266,12.5a1.137,1.137,0,0,1-.914.458",
    transform: "translate(-0.009 1.327)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1-4",
    "data-name": "Fill 1",
    d: "M5.817,13.552a1.13,1.13,0,0,1-.668-.218L0,9.567.59,8.76l5.149,3.767a.136.136,0,0,0,.188-.028L15.193,0l.8.6-9.266,12.5a1.137,1.137,0,0,1-.914.458",
    transform: "translate(-0.009 1.327)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1-5",
    "data-name": "Fill 1",
    d: "M5.817,13.552a1.13,1.13,0,0,1-.668-.218L0,9.567.59,8.76l5.149,3.767a.136.136,0,0,0,.188-.028L15.193,0l.8.6-9.266,12.5a1.137,1.137,0,0,1-.914.458",
    transform: "translate(-0.009 1.327)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1-6",
    "data-name": "Fill 1",
    d: "M5.817,13.552a1.13,1.13,0,0,1-.668-.218L0,9.567.59,8.76l5.149,3.767a.136.136,0,0,0,.188-.028L15.193,0l.8.6-9.266,12.5a1.137,1.137,0,0,1-.914.458",
    transform: "translate(-0.009 1.327)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1-7",
    "data-name": "Fill 1",
    d: "M5.817,13.552a1.13,1.13,0,0,1-.668-.218L0,9.567.59,8.76l5.149,3.767a.136.136,0,0,0,.188-.028L15.193,0l.8.6-9.266,12.5a1.137,1.137,0,0,1-.914.458",
    transform: "translate(-0.009 1.327)",
    fill: "#d8262f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.4ba68d1fea6d8bd663eb813b87c9a5c5.svg";
export { ForwardRef as ReactComponent };